<div class="addContainer">
    <div class="modalHeader">
        <div class="row model-header">
            <div class="col-1">
                <img src="{{ smartaccupay_logo }}" height="45px" width="45px" />
            </div>
            <div class="col-9">
                <div class="editRowModal">
                    <div class="modalHeader m-auto text-center clearfix">
                        <div class="modal-about">
                            <div class="fw-bold p-t-5 p-l-10 font-17">
                                <!-- {{titleMessage}} -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-2 d-flex justify-content-end">

                <button mat-mini-fab matTooltip="{{'COMMON.TOOL_TIP.BACK' | translate}}" mat-dialog-close color="warn"
                    aria-label="Close dialog">
                    <mat-icon class="col-white">close</mat-icon>
                </button>
            </div>
        </div>
    </div>

    <mat-dialog-content class="scrollable-content" infiniteScroll [infiniteScrollDistance]="2"
        [infiniteScrollThrottle]="50" [scrollWindow]="false" (scrolled)="onScroll()" [ngStyle]="setHeightStyles()">
        <div *ngIf="data.type === 'terms'">
            <div [innerHTML]="terms_and_condition"></div>
        </div>
        <div *ngIf="data.type === 'privacy'">
            <div [innerHTML]="privacy_policy"></div>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions mat-dialog-actions align="end">
        <button mat-raised-button color="primary" [disabled]="!isScrolledToBottom" (click)="accept()">Agree</button>
    </mat-dialog-actions>
</div>